function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2v20h20V2H2zm18.746 18.752H3.248V3.248h17.498v17.503zm-6.135-5.038a.571.571 0 01-.491.366h-.246a.571.571 0 01-.365-.731L15.96 8a.58.58 0 111.103.366l-2.452 7.348zm-7.714.366a.571.571 0 00.492-.366l2.445-7.348a.537.537 0 00-.365-.732.537.537 0 00-.732.366l-2.451 7.349a.571.571 0 00.365.731h.246zm3.554 0h-.245a.572.572 0 01-.372-.731L12.286 8a.581.581 0 011.103.366l-2.452 7.348c0 .12-.12.366-.486.366z",
    fill: "#E11F26"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-what3word.svg";